import React from 'react';
import styled from 'styled-components';
import { useSpring, animated, config } from 'react-spring';
import SearchBarContext, { useLockFocus } from './context';

const CrossSymbol = styled(animated.span)`
  position: absolute;
  right: ${props => (props.pseudomobile === 'true' ? 60 : 170)}px;
  top: 1px;
  font-size: ${props => (props.valuelength ? 12 : 24)}px;
  font-weight: bolder;
  color: ${props => props.theme.secondaryColor};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.primaryColor};
  }
`;

export default function Cross() {
  const {
    state: {
      expanded, value, pseudoMobile,
    },
    dispatch,
  } = React.useContext(SearchBarContext);

  const style = useSpring({
    opacity: expanded ? 1 : 0,
    display: expanded ? 'block' : 'none',
    config: config.slow,
  });

  const onClicked = e => {
    e && e.preventDefault();
    if (value.length) {
      dispatch({ type: 'setValue', payload: '' });
      dispatch({ type: 'setQuery', payload: '' });
      dispatch({ type: 'resetCaret' });
    } else {
      dispatch({ type: 'inputFocus', payload: false });
      dispatch({ type: 'expand', payload: false });
    }
  };

  return (
    <CrossSymbol
      {...useLockFocus()}
      onClick={onClicked}
      pseudomobile={pseudoMobile.toString()}
      valuelength={value.length}
      style={style}
    >
      {value.length ? 'clear' : '\u00d7' }
    </CrossSymbol>
  );
}
